/* global axios */
import ApiClient from './ApiClient';

class BroadcastsAPI extends ApiClient {
  constructor() {
    super('broadcasts', { accountScoped: true });
  }

  // Returns reach and cost estimate without sending anything.
  preview(id) {
    return axios.post(`${this.url}/${id}/preview`);
  }

  trigger(id) {
    return axios.post(`${this.url}/${id}/trigger`);
  }
}

export default new BroadcastsAPI();
